export interface FacelockSessionResult {
  sessionId: string;
  url: string;
  emailed: boolean;
  emailError?: string;
  persisted: boolean;
}

export async function requestFacelockIdvSession(input: {
  applicantId?: string;
  email: string;
  name: string;
  phone?: string;
  dateOfBirth?: string;
  address?: string;
}): Promise<FacelockSessionResult> {
  const response = await fetch("/api/facelock/session", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(input),
  });
  const text = await response.text();
  let parsed: Partial<FacelockSessionResult> & { error?: string } = {};
  try {
    parsed = text ? JSON.parse(text) as typeof parsed : {};
  } catch {
    parsed = {};
  }
  if (!response.ok && !parsed.sessionId) {
    throw new Error(parsed.error || `FaceLock session request failed (${response.status})`);
  }
  if (!parsed.sessionId || !parsed.url) {
    throw new Error(parsed.error || parsed.emailError || "FaceLock session response was incomplete");
  }
  return {
    sessionId: parsed.sessionId,
    url: parsed.url,
    emailed: Boolean(parsed.emailed),
    emailError: parsed.emailError,
    persisted: Boolean(parsed.persisted),
  };
}
